<section class="vm-hero" aria-labelledby="vm-hero-title">
  <picture class="vm-hero__media">
    <source media="(min-width: 1024px)" [srcset]="desktopImage" />
    <img [src]="mobileImage" alt="" />
  </picture>
  <img [src]="logoImage" alt="Virgin Mobile" class="vm-hero__logo" />
  <div class="vm-hero__content onboarding-content">
    <p class="vm-hero__eyebrow">{{ eyebrow }}</p>
    <h1 id="vm-hero-title" class="vm-hero__title">{{ title }}</h1>
    <p class="vm-hero__body">
      {{ body }}
    </p>
    <button type="button" routerLink="/activate-sim" class="vm-hero__cta">
      {{ cta }}
    </button>
  </div>
</section>
